import React from 'react';
import { BrokerDataSection } from './BrokerDataSection';
import { ClientDataSection } from './ClientDataSection';
import { VisitDataSection } from './VisitDataSection';

interface VisitFormProps {
  formData: any;
  setFormData: (data: any) => void;
  visitConfig: any;
  minDate: string;
  isBrokerProfile: boolean;
  isClientView?: boolean;
  isReconocimiento?: boolean;
  onNext: () => void;
  onCancel: () => void;
}

const countryCodes = [{ value: '+57', label: 'co +57' }, { value: '+1', label: 'us +1' }, { value: '+34', label: 'es +34' }];
const DAYS_ORDER = ["LUNES", "MARTES", "MIERCOLES", "JUEVES", "VIERNES", "SABADO", "DOMINGO"];

export const VisitForm: React.FC<VisitFormProps> = ({ formData, setFormData, visitConfig, minDate, isBrokerProfile, isClientView, isReconocimiento = false, onNext, onCancel }) => {
  const labelStyle = "block text-[10px] font-black text-gray-400 uppercase mb-1";
  const inputStyle = "w-full border border-gray-300 rounded-lg text-sm px-3 py-2 bg-white text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-sky-500/20 focus:border-sky-500 focus:outline-none transition-all shadow-sm";
  const readOnlyStyle = "w-full border border-gray-200 bg-gray-50 rounded-lg text-sm px-3 py-2 text-gray-500 cursor-not-allowed shadow-sm";

  const isValidEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const isEmailInvalid = formData.email_cliente && !isValidEmail(formData.email_cliente);
  const isBrokerEmailInvalid = formData.email_broker && !isValidEmail(formData.email_broker);

  const isDuplicateEmail = !isClientView && 
                           !isReconocimiento &&
                           formData.email_broker && 
                           formData.email_cliente && 
                           formData.email_broker.toLowerCase() === formData.email_cliente.toLowerCase();

  const isDuplicatePhone = !isClientView && 
                           !isReconocimiento &&
                           formData.celular_broker && 
                           formData.celular_cliente && 
                           formData.celular_broker === formData.celular_cliente;

  const isDocumentDuplicate = !isClientView &&
                              !isReconocimiento &&
                              Boolean(formData.cc_broker &&
                              formData.document_cliente &&
                              formData.cc_broker.trim() === formData.document_cliente.trim());

  const isDocumentInvalid = Boolean(
    formData.document_cliente && 
    (formData.document_cliente.length < 7 || formData.document_cliente.length > 20 || !/^\d+$/.test(formData.document_cliente))
  );

  const isClientDocValid = Boolean(
    formData.document_cliente &&
    formData.document_cliente.length >= 7 &&
    formData.document_cliente.length <= 20 &&
    /^\d+$/.test(formData.document_cliente) &&
    !isDocumentDuplicate
  );

  const isSameDay = formData.fecha1 && formData.fecha2 && formData.fecha1 === formData.fecha2;

  const isFormValid = formData.fecha1 && formData.hora1 && formData.fecha2 && formData.hora2 && 
                     formData.nombre_broker && formData.email_broker && isValidEmail(formData.email_broker) &&
                     formData.celular_broker && !isDuplicateEmail && !isDuplicatePhone && !isSameDay &&
                     (!!isClientView || isReconocimiento || (
                       formData.nombre_cliente && 
                       formData.email_cliente && 
                       isValidEmail(formData.email_cliente) && 
                       (!isBrokerProfile || formData.last_name) &&
                       isClientDocValid
                     )) &&
                     (formData.llaves_quien !== 'otro' || (formData.llaves_nombre?.trim() && formData.llaves_telefono?.trim() && formData.llaves_documento?.trim()));

  return (
    <div className="overflow-y-auto custom-scrollbar flex-grow">
      <div className="p-8 space-y-10">
        <BrokerDataSection 
          formData={formData} setFormData={setFormData} isClientView={!!isClientView}
          labelStyle={labelStyle} inputStyle={inputStyle} readOnlyStyle={readOnlyStyle}
          isBrokerEmailInvalid={isBrokerEmailInvalid || false} countryCodes={countryCodes}
        />

        {!isClientView && !isReconocimiento && (
          <ClientDataSection 
            formData={formData} setFormData={setFormData} labelStyle={labelStyle} inputStyle={inputStyle}
            isEmailInvalid={isEmailInvalid || false} isDuplicateEmail={isDuplicateEmail || false}
            isDuplicatePhone={isDuplicatePhone || false}
            isDocumentDuplicate={isDocumentDuplicate || false}
            isDocumentInvalid={isDocumentInvalid || false}
            isBrokerProfile={isBrokerProfile} countryCodes={countryCodes}
          />
        )}

        <VisitDataSection 
          formData={formData} setFormData={setFormData} visitConfig={visitConfig} minDate={minDate}
          labelStyle={labelStyle} inputStyle={inputStyle} isSameDay={isSameDay || false} DAYS_ORDER={DAYS_ORDER}
        />
      </div>

      <footer className="sticky bottom-0 bg-white px-8 py-6 border-t border-gray-100 flex justify-end gap-3 z-20 shadow-lg">
        <button type="button" onClick={onCancel} className="px-8 py-3 text-xs font-black uppercase text-gray-400">Cancelar</button>
        <button type="button" onClick={onNext} disabled={!isFormValid} className="px-10 py-3 bg-[#00234F] text-white rounded-xl font-black uppercase text-xs shadow-xl disabled:opacity-30">
          Siguiente
        </button>
      </footer>
    </div>
  );
};
